export enum BlockCategory {
    Input = 'input',
    Output = 'output',
    Prep = 'prep',
    MachineLearning = 'ml',
    Control = 'control',
}
